import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useDataSaver } from "@/context/DataSaverContext";
import { ChevronRight, Zap, LogIn, LayoutDashboard } from "lucide-react";

const LINKS = [
  ["About", "/about"], ["Delegations", "/delegations"], ["Events", "/events"],
  ["Impact", "/impact"], ["News", "/news"], ["Sponsors", "/sponsors"],
  ["Apply to Compete", "/apply"], ["Coronation", "/coronation"], ["Titleholders", "/alumni"],
  ["Shop", "/shop"], ["Membership", "/membership"],
  ["Support", "/support"], ["Become a Sponsor", "/sponsors"],
];

export default function More() {
  const { user } = useAuth();
  const { dataSaver, toggle } = useDataSaver();
  return (
    <div className="section py-12" data-testid="more-page">
      <h1 className="text-4xl text-amber-50">More</h1>
      <div className="mt-8 card-lux divide-y divide-gold/10">
        {LINKS.map(([label, to]) => (
          <Link key={label} to={to} className="flex items-center justify-between p-4 hover:bg-obsidian-600">
            <span className="text-amber-50">{label}</span><ChevronRight className="h-4 w-4 text-gold/60" />
          </Link>
        ))}
        <Link to={user ? "/account" : "/login"} className="flex items-center justify-between p-4 hover:bg-obsidian-600">
          <span className="flex items-center gap-2 text-amber-50">{user ? <LayoutDashboard className="h-4 w-4 text-gold" /> : <LogIn className="h-4 w-4 text-gold" />} {user ? "My Account" : "Sign In"}</span>
          <ChevronRight className="h-4 w-4 text-gold/60" />
        </Link>
        {(user?.role === "admin" || user?.role === "super_admin") && (
          <Link to="/admin" className="flex items-center justify-between p-4 hover:bg-obsidian-600">
            <span className="flex items-center gap-2 text-gold"><LayoutDashboard className="h-4 w-4" /> Command Center</span><ChevronRight className="h-4 w-4 text-gold/60" />
          </Link>
        )}
        <button onClick={toggle} className="flex w-full items-center justify-between p-4 hover:bg-obsidian-600 text-left">
          <span className="flex items-center gap-2 text-amber-50"><Zap className="h-4 w-4 text-emerald-accent" /> Data Saver Mode</span>
          <span className={`font-mono text-xs ${dataSaver ? "text-emerald-accent" : "text-muted-foreground"}`}>{dataSaver ? "ON" : "OFF"}</span>
        </button>
      </div>
    </div>
  );
}
